<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="para"><a id="page_ii"></a>ALSO BY MAGGIE BARBIERI</p>
<p class="para"> </p>
<p class="para"><em>Quick Study</em></p>
<p class="para"> </p>
<p class="para"><em>Extracurricular Activities</em></p>
<p class="para"> </p>
<p class="para"><em>Murder 101</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?17689fb8